<template>
  <div>
    <DataCenterLoading v-if="toc_list.length === 0" />

    <template v-else-if="!print_mode">
      <div v-for="(lv1_info, lv1_idx) in toc_list" :key="'toc_lv1_' + lv1_idx">
        <h2
          v-if="lv1_info"
          class="fw-600 mb-5"
          :class="selected_report?.story_board ? '' : 'mt-5'"
          :id="!print_mode ? 'toc_lv1_' + lv1_idx : ''"
        >
          {{
            lang !== 'ENG' ? lv1_info.name : lv1_info.name_em ? lv1_info.name_em : lv1_info.name_ea
          }}
        </h2>

        <div v-for="(lv2_info, lv2_idx) in lv1_info.children" :key="'toc_lv2_' + lv2_idx">
          <div v-if="lv2_info.children.length > 0" class="mb-5">
            <div class="flex-grow-1 py-1 pl-1" :style="main_color_sub">
              <span class="fw-600 f-140" :id="!print_mode ? 'toc_lv2_' + lv1_idx + lv2_idx : ''">
                {{
                  lang !== 'ENG'
                    ? lv2_info.name
                    : lv2_info.name_em
                      ? lv2_info.name_em
                      : lv2_info.name_ea
                }}
              </span>
            </div>

            <div
              v-for="(lv3_info, lv3_idx) in lv2_info.children"
              :key="'data_center_lv2_' + lv3_idx"
            >
              <b-row>
                <b-col cols="12">
                  <div class="mb-3">
                    <ChartCanvas
                      v-if="lv3_info.item_id !== '' && lv3_info.type === 'chart'"
                      :chart_id="lv3_info.item_id"
                      :print_mode="print_mode"
                      :key="`chart_${lv3_info.item_id}`"
                      :viewer_mode="true"
                      class="mb-5"
                    />

                    <data-table
                      v-if="lv3_info.item_id !== '' && lv3_info.type === 'table'"
                      :print_mode="print_mode"
                      :table_mode="table_mode"
                      :data_table_id="lv3_info.item_id"
                      :modal_table="modal_table"
                      :lazy_load="false"
                      :table_style="table_style"
                      :show_table_line="show_table_line"
                      :show_table_outline="show_table_outline"
                      :table_header_color="table_header_color"
                      :table_header_font_color="table_header_font_color"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="print_mode">
      <div v-for="(lv1_info, lv1_idx) in toc_list" :key="'datacenter' + lv1_idx">
        <h3 v-if="lv1_info" class="py-3" :class="{
          'page-no-break-before':
            print_mode &&
            selected_report?.story_board &&
            lv1_idx === 0,
          'page-break-before':
            print_mode &&
            selected_report?.story_board &&
            lv1_idx > 0
        }">
          {{
            lang !== 'ENG' ? lv1_info.name : lv1_info.name_em ? lv1_info.name_em : lv1_info.name_ea
          }}
        </h3>
        <div
          v-for="(lv2_info, lv2_idx) in lv1_info.children"
          :key="'datacenter_lv2' + lv2_idx"
          responsive
          class="table-borderless table-responsive"
        >
          <div class="mb-2 border-0">
            <div class="flex-grow-1 py-1 pl-1" :style="main_color_sub">
              <span class="fw-600 f-140" :id="!print_mode ? 'toc_lv2_' + lv1_idx + lv2_idx : ''">
                {{
                  lang !== 'ENG'
                    ? lv2_info.name
                    : lv2_info.name_em
                      ? lv2_info.name_em
                      : lv2_info.name_ea
                }}
              </span>
            </div>

            <b-row
              v-for="(lv3_info, lv3_idx) in lv2_info.children"
              :key="'data_center_lv2_' + lv3_idx"
            >
              <b-col cols="12">
                <div class="mb-3">
                  {{
                    lang !== 'ENG'
                      ? lv3_info.contents
                      : lv3_info.contents_em
                        ? lv3_info.contents_em
                        : lv3_info.contents_ea
                  }}
                  <ChartCanvas
                    v-if="lv3_info.item_id !== '' && lv3_info.type === 'chart'"
                    :chart_id="lv3_info.item_id"
                    :print_mode="print_mode"
                    :key="`chart_${lv3_info.item_id}`"
                    :viewer_mode="true"
                    class="mb-5"
                  />

                  <data-table
                    v-if="lv3_info.item_id !== '' && lv3_info.type === 'table'"
                    :print_mode="print_mode"
                    :table_mode="table_mode"
                    :data_table_id="lv3_info.item_id"
                    :modal_table="modal_table"
                    :lazy_load="false"
                    :table_style="table_style"
                    :show_table_line="show_table_line"
                    :show_table_outline="show_table_outline"
                    :table_header_color="table_header_color"
                    :table_header_font_color="table_header_font_color"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import DataTable from './DataTable.vue';
  import DataCenterLoading from './DataCenterLoading.vue';
  import ChartCanvas from '@/components/writing_report/chart_subs/ChartCanvas.vue';

  export default {
    name: 'DataCenterTableSb',
    props: {
      modal_table: { type: Boolean, default: false },
      print_mode: { type: Boolean, default: false },
      table_mode: { type: String, default: 'accordion' },
      material_style_option: { type: String, default: 'fill' },
      table_style: { type: String, default: 'basic_table' },
      show_table_line: { type: Boolean, default: true },
      show_table_outline: { type: Boolean, default: false },
      table_header_color: { type: String, default: '#dedede' },
      table_header_font_color: { type: String, default: '#fffff' },
    },
    components: {
      DataTable,
      ChartCanvas,
      DataCenterLoading,
    },
    computed: {
      ...mapState('report_list', ['lang']),
      ...mapGetters('report_list', ['selected_report', 'current_report_code']),
      ...mapState('charts', ['toc_list']),
      ...mapState('data_center', ['lv1_key', 'lv2_key']),
      selected_lv2_info() {
        if (this.lv1_key !== '' && this.lv2_key) {
          if (this.lv2_key === '') {
            return this.toc_list.find((obj) => obj['key'] === this.lv1_key).children[0];
          } else {
            return this.toc_list
              .find((obj) => obj['key'] === this.lv1_key)
              .children.find((obj) => obj['key'] === this.lv2_key);
          }
        } else {
          return this.toc_list[0].children[0];
        }
      },
      main_color_sub() {
        if (this.material_style_option === 'fill') {
          return `background-color: ${this.selected_report.main_color}; color: white; border: 1px solid white; `;
        } else if (this.material_style_option === 'outline') {
          return (
            `color:` +
            this.selected_report.main_color +
            `; border-top: 1px solid ` +
            this.selected_report.main_color +
            `!important` +
            `; border-bottom: 1px solid ` +
            this.selected_report.main_color
          );
        } else {
          return `background-color: white; border-left: 3px solid ${this.selected_report.main_color}; border-bottom: 1px solid ${this.selected_report.sub_color}; border-top: 0px; border-right: 0px;`;
        }
      },
    },
    mounted() {
      this.getDCToC({ report_code: this.current_report_code });
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.checkSticky);
    },
    methods: {
      ...mapActions('charts', ['getDCToC']),
    },
  };
</script>

<style></style>
